export {
  GetStopListDepOrArrEnum as DEP_OR_ARR_VALUE,
  TicketStatus
} from '@linktivity/limousinerelayless';

export const dateFormat = 'yyyy-MM-dd';
export const timeFormat = 'HH:mm';
export const timestampFormat = `${dateFormat} ${timeFormat}`;

export const ADULT_NUM = 'adultNum';
export const CHILD_NUM = 'childNum';
export const DEP_BUS_STOP_NAME = 'depBusStopName';
export const DEP_BUS_STOP_CODE = 'depBusStopCode';
export const ARR_BUS_STOP_NAME = 'arrBusStopName';
export const ARR_BUS_STOP_CODE = 'arrBusStopCode';
export const DEP_TIME = 'depTime';
export const ARR_TIME = 'arrTime';
export const SERVICE_DATE = 'serviceDate';
export const DEP_OR_ARR = 'depOrArr';
export const T_URL = 'tUrl';
export const REMAINS = 'remains';

export const ACCEPTANCE_STOP = 'Acceptance_STOP';
